import React from 'react'
import { Card, CardBody, Col, Row } from "reactstrap";
import { getFilterCount } from "../../mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { initialFilter, labelStyles } from './constants';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import SelectMaterialElasticSearch from '../onBoardingMaterialIdSetup/SelectMaterialElasticSearch';
import { hardcodeDropdown } from "./constants";
import { useState } from 'react'
import { updateRequest } from "views/pages/manage/edpOps/constant/common";


const FilterForm = ({
  closePopup,
  dropdownData,
  globalFilter,
  setGlobalFilter,
  filterCount,
  setFilterCount,
  searchHandler,
  setRows
}) => {

  const filterFormHandler = (key, value) => {
    setGlobalFilter((prev) => ({ ...prev, [key]: value ?? [], PrNo: '' }));
  };

  const handleApplyFilter = () => {
    const filterCount = getFilterCount(globalFilter);
    setFilterCount(filterCount);
    searchHandler({ ...updateRequest(globalFilter), DateHigh: moment(globalFilter?.DateHigh).format("YYYYMMDD"), DateLow: moment(globalFilter?.DateLow).format("YYYYMMDD") });
    closePopup();
  };
  const removeFilterHandler = () => {
    // searchHandler(initialFilter);
    setGlobalFilter((prev) => (initialFilter));
    setFilterCount(0);
    closePopup();
    setRows({});
  };
  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="mb-1 d-flex align-items-start justify-content-between">
          <div className="regular-large-bold">Filters</div>
        </div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Account Assignment"
            currentValue={globalFilter?.AccountAssignment}
            items={hardcodeDropdown?.Account_asignment}
            handleChange={(value) => {
              filterFormHandler("AccountAssignment", value);
            }}
            selectAllMenuButton={true}
            isShowCount={true}
            isMulti={false}
            isClearable={true}
          />

          <AAutoComplete
            label="Plant*"
            currentValue={globalFilter?.Plant}
            items={[
              ...(dropdownData?.allActiveBu || []),
              ...hardcodeDropdown.additionalPlant
            ]}
            handleChange={(value) => {
              filterFormHandler("Plant", value);
            }}
            selectAllMenuButton={true}
            isShowCount={true}
            isMulti={false}
            isClearable={true}
          />

          <div style={labelStyles}>Material</div>
          <SelectMaterialElasticSearch
            currentValue={globalFilter?.MaterialNo}
            handleChange={(value) => {
              filterFormHandler("MaterialNo", value);
            }}
            isMulti={false}
            // plantId={globalFilter?.Plant?.value}
            // isDisabled={!globalFilter?.Plant}
            dropdownMappingParams={[
              "materialIdAndDescription",
              "materialId",
              "materialDescription",
            ]}
          />

          <div style={labelStyles}>Vendor</div>
          <SelectMaterialElasticSearch
            currentValue={globalFilter?.Vendor}
            handleChange={(value) => {
              filterFormHandler("Vendor", value);
            }}
            isMulti={false}
            dropdownMappingParams={[
              "vendorCodeAndName",
              "vendorCode",
              "name"
            ]}
            category="VendorMaster"
            isPlantIdRequired={false}
          />

          {/* <AAutoComplete
            label="Service"
            currentValue={globalFilter?.Services}
            items={hardcodeDropdown?.serviceFilter}
            handleChange={(value) => {
              filterFormHandler("Services", value);
            }}
            selectAllMenuButton={true}
            isShowCount={true}
            isMulti={false}
          /> */}

          <AAutoComplete
            label="Doc Type"
            currentValue={globalFilter?.Doc_Type}
            handleChange={(value) => {
              filterFormHandler("Doc_Type", value);
            }}
            items={hardcodeDropdown?.Doc_Type}
            isMulti={false}
            placeholder={"DOC TYPE*"}
            height="44px"
            isClearable={true}
          />

          <div style={labelStyles}>Purchase Requisition Date*</div>
          <div className={"d-flex flex justify-content-between"} style={{ columnGap: '10px' }}>
            <CustomDatePickerV2
              placeHolder="From"
              // maxDate={moment(new Date())}
              value={globalFilter?.DateLow}
              width={"18px"}
              handler={(index, date, keyName) => {
                filterFormHandler("DateLow", moment(date).startOf('day'));
                filterFormHandler("DateHigh", moment(new Date()).endOf('day'));
              }}
            />
            <CustomDatePickerV2
              placeHolder="To"
              width={"18px"}
              // maxDate={moment(new Date())}
              value={globalFilter?.DateHigh}
              handler={(index, date, keyName) => {
                filterFormHandler("DateHigh", moment(date).endOf('day'));
              }}
            />
          </div>
        </div>

        <div className="mt-3 d-flex flex-row-reverse justify-content-between">
          <AButton
            variant="primary_filled"
            className="button_remove_left_margin"
            onClick={() => {
              handleApplyFilter();
            }}
            disabled={getFilterCount({ ...globalFilter }) === 0 || !(globalFilter?.Plant && globalFilter?.DateLow && globalFilter?.DateHigh)}
          >
            Apply filter
          </AButton>

          {filterCount > 0 && (
            <AButton
              variant="outline"
              className="button_remove_left_margin"
              updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
              onClick={removeFilterHandler}
            >
              Remove
            </AButton>
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default FilterForm;